import React, { useState, useMemo } from "react";
import { Link } from "react-router-dom";
import { BLOG_ARTICLES, BLOG_CATEGORIES } from "../data/blogData";
import { useSEO } from "../hooks/useSEO";

export default function Blog() {
  useSEO({
    title: "Blog Immobilier - Conseils et Guides",
    description: "Découvrez nos articles et guides sur l'immobilier : financement, investissement locatif, fiscalité, achat et vente. Conseils d'experts gratuits."
  });

  const [category, setCategory] = useState("Tous");
  const [searchQuery, setSearchQuery] = useState("");

  const filteredArticles = useMemo(() => {
    return BLOG_ARTICLES.filter((article) => {
      const matchesCategory = category === "Tous" || article.category === category;
      const matchesSearch = article.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
                           article.excerpt.toLowerCase().includes(searchQuery.toLowerCase());
      return matchesCategory && matchesSearch;
    });
  }, [category, searchQuery]);

  return (
    <div className="page">
      <div className="hero">
        <h1>Blog Immobilier</h1>
        <p className="muted" style={{ margin: 0 }}>
          Conseils, guides et actualités pour vos projets immobiliers.
        </p>
      </div>

      <div style={{ height: 24 }} />

      {/* Filtres */}
      <div className="card" style={{ marginBottom: 24 }}>
        <div style={{ display: "flex", gap: 12, flexWrap: "wrap", alignItems: "center" }}>
          <input
            type="text"
            placeholder="Rechercher un article..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="input"
            style={{ flex: "1 1 300px", marginTop: 0 }}
          />

          <select
            value={category}
            onChange={(e) => setCategory(e.target.value)}
            className="select"
            style={{ flex: "0 0 180px", marginTop: 0 }}
          >
            {BLOG_CATEGORIES.map((cat) => (
              <option key={cat} value={cat}>{cat}</option>
            ))}
          </select>
        </div>

        {/* Pills catégories */}
        <div className="pillRow" style={{ marginTop: 16 }}>
          {BLOG_CATEGORIES.map((cat) => (
            <button
              key={cat}
              onClick={() => setCategory(cat)}
              className={`pill ${category === cat ? "pillActive" : ""}`}
            >
              {cat}
            </button>
          ))}
        </div>
      </div>

      {/* Liste des articles */}
      {filteredArticles.length === 0 ? (
        <div className="card" style={{ textAlign: "center", padding: 40 }}>
          <p className="muted">Aucun article trouvé.</p>
        </div>
      ) : (
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(320px, 1fr))",
            gap: 20,
          }}
        >
          {filteredArticles.map((article) => (
            <Link
              key={article.id}
              to={`/blog/${article.slug}`}
              className="card card-hover"
              style={{
                textDecoration: "none",
                color: "inherit",
                padding: 0,
                overflow: "hidden",
              }}
            >
              {/* Image header */}
              <div
                style={{
                  height: 160,
                  background: `linear-gradient(135deg, ${article.gradient})`,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: 56,
                }}
              >
                {article.emoji}
              </div>

              {/* Content */}
              <div style={{ padding: 20 }}>
                {/* Meta */}
                <div style={{ display: "flex", gap: 12, marginBottom: 12 }}>
                  <span
                    style={{
                      fontSize: 12,
                      fontWeight: 600,
                      color: "#1e40af",
                      textTransform: "uppercase",
                      letterSpacing: "0.05em",
                    }}
                  >
                    {article.category}
                  </span>
                  <span style={{ fontSize: 12, color: "#94a3b8" }}>
                    {article.date}
                  </span>
                  <span style={{ fontSize: 12, color: "#94a3b8" }}>
                    {article.readTime} de lecture
                  </span>
                </div>

                {/* Title */}
                <h3
                  style={{
                    margin: "0 0 8px 0",
                    fontSize: 18,
                    fontWeight: 600,
                    color: "#1e293b",
                    lineHeight: 1.4,
                  }}
                >
                  {article.title}
                </h3>

                {/* Excerpt */}
                <p
                  style={{
                    margin: 0,
                    fontSize: 14,
                    color: "#64748b",
                    lineHeight: 1.6,
                  }}
                >
                  {article.excerpt}
                </p>

                {/* Read more */}
                <div
                  style={{
                    marginTop: 16,
                    fontSize: 14,
                    fontWeight: 600,
                    color: "#1e40af",
                  }}
                >
                  Lire l'article →
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
